import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ProdConfig } from './blocks/config/prod.config';
import { MainModule } from './main.module';

function main() {
    const STARTED_AS_HOT = 'hot';

    ProdConfig();

    if (module[STARTED_AS_HOT]) {
        module[STARTED_AS_HOT].accept();
    }

    platformBrowserDynamic().bootstrapModule(MainModule)
        .then((success) => console.log(`Application started!`))
        .catch((error) => console.error(error));
}

main();



// WEBPACK FOOTER //
// ./src/main/webapp/app/main.ts